import React from 'react';
import './section4-p3.css';
import FeatureCard from '../components/common/FeatureCard';
import bed from '../assets/Bed.png'; 
import bath from '../assets/Bath.png';
import measure from '../assets/measure.png';
import garden from '../assets/garden.png';
import waves from '../assets/waves.png';
import car from '../assets/car.png';

const SectionFourP4 = () => {
  const features = [
    { icon: bed, title: "4 Spacious Bedrooms", subtitle: "Spacious, comfortable and luxurious" },
    { icon: garden, title: "Private Garden", subtitle: "Perfect for entertaining outdoors." },
    { icon: bath, title: "2 Modern Bathrooms", subtitle: "Modern fixtures, finishes and features" },
    { icon: waves, title: "Swimming Pool", subtitle: "Your own space to unwind and enjoy." },
    { icon: measure, title: "800 sqm", subtitle: "Total Area: 800 sqm of expansive space" },
    { icon: car, title: "2 Parking Spaces", subtitle: "Private and secure parking spaces." }
  ];

  return (
    <section className='sec--4-wrapper'>
    <section className="section4-wrapper">
      <h2 className="section-heading">Key Features:</h2>
      <div className="features-grid">
        {features.map((item, index) => (
          <FeatureCard 
            key={index} 
            icon={item.icon} 
            title={item.title} 
            subtitle={item.subtitle} 
          />
        ))}
      </div>
    </section>
    </section>
  );
};

export default SectionFourP4;